import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { environment } from '@environment/environment';

import { AnalyticsService } from './analytics.service';

@Injectable({
    providedIn: 'root',
})
export class VisitPageGuard {
    constructor(private analyticsService: AnalyticsService) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Promise<boolean> {
        this.analyticsService.startTracking(route?.data?.appRoute, state?.url);
        return Promise.resolve(true);
    }
}
